import { issueInvoicePageViewList } from "pages/IssueInvoice/utils";
import React from "react";
import ListInvoice from "./ListInvoice";

const ListSaleInvoiceHaveCode = () => {
  const filterList = {
    // "filter[ttchung_khmshdon]": "2", // Invoice Type [Sale Invoice]
    // "filter[invoice_type]": "1", // Have Code
  };

  return (
    <React.Fragment>
      <ListInvoice
        filterList={filterList}
        title={"title.issue_sales_invoice_have_code"}
        titleManger={"titleManger.issue_sales_invoice"}
        pageView={issueInvoicePageViewList.PAGE_SALE_INVOICE_HAVE_CODE}
      />
    </React.Fragment>
  );
};

export default ListSaleInvoiceHaveCode;
